<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header [label]="'SETTINGS.NAINAT_SETTINGS' | translate" [dialogRef]='dialogRef' [object]='this'></dialog-header>
  <mat-card class="display-settings">
    <!-- Nai -->
    <mat-selection-list dense>
      <mat-list-option [class]="'selection-list-option'" checkboxPosition="before" [selected]="nai"
        (click)="naiBoxClick($event)">
        {{'NAT_NAI.NAI' | translate}}
      </mat-list-option>
    </mat-selection-list>

    <div #ColorButtonNai class="slider-with-label" fxLayout="row">
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
        matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onNaiColorClick()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconNai()}">color_lens</mat-icon>
        {{'NAT_NAI.NAI_COLOR' | translate}}
      </button>
    </div>

    <div class="slider-with-label" fxLayout="row" fxLayoutAlign="left center">
      <span>{{'NAT_NAI.NAI_FILL_OPACITY' | translate}}</span>
      <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
        min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="naiFillOpacity"
        (change)="naiBrightnessSliderChanged($event)">
      </mat-slider>
    </div>

    <mat-divider></mat-divider>

    <!-- Nat -->
    <mat-selection-list dense>
      <mat-list-option [class]="'selection-list-option'" checkboxPosition="before" [selected]="nat"
        (click)="natBoxClick($event)">
        {{'NAT_NAI.NAT' | translate}}
      </mat-list-option>
    </mat-selection-list>

    <div #ColorButtonNat class="slider-with-label" fxLayout="row">
      <button mat-icon-button [matTooltip]="'MAP.COLOR' | translate" matTooltipPosition="below"
        matTooltipShowDelay="2000" [disabled]="isColorPickerActive()" (click)="onNatColorClick()">
        <mat-icon class="color-picker-icon" [ngStyle]="{'background': colorPickerIconNat()}">color_lens</mat-icon>
        {{'NAT_NAI.NAT_COLOR' | translate}}
      </button>
    </div>

    <div class="slider-with-label" fxLayout="row" fxLayoutAlign="left center">
      <span> {{'NAT_NAI.NAT_FILL_OPACITY' | translate}} </span>
      <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
        min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="natFillOpacity"
        (change)="natBrightnessSliderChanged($event)">
      </mat-slider>
    </div>

  </mat-card>
</div>